import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { CaseEndpoint } from '../../types/case-container'
import {
  BlockedStep,
  CheckingStep,
  ConfirmStep,
  ModalHeader,
  WarningStep,
} from './delete-confirmation-modal/delete-confirmation-modal.parts'
import { useDeleteConfirmationModal } from './delete-confirmation-modal/use-delete-confirmation-modal'

interface DeleteConfirmationModalProps {
  endpoints: CaseEndpoint[]
  onClose: () => void
  onConfirm: () => Promise<void>
  deleting: boolean
}

export function DeleteConfirmationModal(props: DeleteConfirmationModalProps): ReactElement {
  const { endpoints, onClose, onConfirm, deleting } = props
  const { t } = useTranslation('cases')
  const { step, linkedItems, handleProceed } = useDeleteConfirmationModal(endpoints)
  const count = endpoints.length

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-lg rounded-xl bg-white p-6 shadow-xl dark:bg-slate-900">
        <ModalHeader count={count} deleting={deleting} onClose={onClose} t={t} />
        {step === 'warning' && (
          <WarningStep
            endpoints={endpoints}
            count={count}
            onClose={onClose}
            onProceed={handleProceed}
            t={t}
          />
        )}
        {step === 'checking' && <CheckingStep t={t} />}
        {step === 'blocked' && <BlockedStep linkedItems={linkedItems} onClose={onClose} t={t} />}
        {step === 'confirm' && (
          <ConfirmStep
            count={count}
            deleting={deleting}
            onClose={onClose}
            onConfirm={onConfirm}
            t={t}
          />
        )}
      </div>
    </div>
  )
}
